/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Image } from 'react-bootstrap';

export interface IAcquisitionProps {
  icon?: string | any;
  label?: string;
  value?: string;
}

export interface IAcquisitionWidgetProps {
  title: string;
  description?: string;
  acquisitions: IAcquisitionProps[];
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const AcquisitionWidget = ({
  title,
  description,
  acquisitions,
}: IAcquisitionWidgetProps) => {
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image key={`image-icon`} src={Icon} width={60} height={60} />
        );
      } else {
        const HeroIcon = require('@heroicons/react/solid');
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(<NavIcon key={`hero-icon`} src={Icon} />);
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(<Icon key={`hero-icon-2`} />);
    }
    return _icon;
  };

  const _renderDescriptionIf = () => {
    if (description) {
      return <p>{description}</p>;
    }
  };
  const _renderLabelIf = (acquisition: any) => {
    if (acquisition?.label) {
      return <label className="mb-0">{acquisition?.label}</label>;
    }
  };

  const _renderValueIf = (acquisition: any) => {
    if (acquisition?.value) {
      return <h4 className="mb-0">{acquisition?.value}</h4>;
    }
  };

  const _renderAcquisitionIf = () => {
    if (acquisitions) {
      return (
        <div className="d-block">
          {acquisitions?.map((acquisition, index) => (
            <div
              key={`acquisition-${index}`}
              className="d-flex align-items-center pt-3"
            >
              <div className="icon-shape icon-sm icon-shape-primary rounded me-3">
                {_getIcon(acquisition?.icon)}
              </div>
              <div className="d-block">
                {_renderLabelIf(acquisition)}
                {_renderValueIf(acquisition)}
              </div>
            </div>
          ))}
        </div>
      );
    }
  };
  if (title) {
    return (
      <>
        <Card border="0" className="shadow">
          <Card.Body>
            <h2 className="fs-5 fw-bold mb-1">{title}</h2>
            {_renderDescriptionIf()}
            {_renderAcquisitionIf()}
          </Card.Body>
        </Card>
      </>
    );
  }
  return null;
};

AcquisitionWidget.defaultProps = {};
